export const navItems = [
    { text: 'Home', link: '/', active: true },
    { text: 'Services', link: '/services/bank-account-opening' },
    { text: 'Pricing', link: '/pricing' },
    { text: 'About Us', link: '/about-us' },
    { text: 'Blog', link: '/blog' },
    { text: 'Contact Us', link: '/contact' },
];